import { useContext } from 'react';

import { ModalContext } from './modal-context';

function useModal() {
  return useContext(ModalContext);
}

export { useModal };
